import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../assests/leftArrow.svg";
import { toastr } from 'react-redux-toastr';
import './SubCategoryForm.css';

const SubCategoryCreateComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const category = location.state?.categoryData;

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    status: 'active',
    image_url: '',
  });
  const [imagePreview, setImagePreview] = useState('');
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const isFormValid = formData.name.trim() !== '';

  useEffect(() => {
    if (!category) {
      toastr.error("Error", "No category data found");
      navigate(-1);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (status) => {
    setFormData(prev => ({ ...prev, status }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFormData(prev => ({ ...prev, image_url: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    const file = e.dataTransfer.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFormData(prev => ({ ...prev, image_url: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid) {
      console.log("Sub Category Created:", formData);
      toastr.success("Success", "Sub category created successfully!");
      navigate(-1);
    }
  };

  if (!category) {
    return null;
  }

  return (
    <div className="subcategory-form-container">
      <Sidebar />
      
      <div className="subcategory-form-content">
        <div className="subcategory-form-header">
          <button className="subcategory-form-back-btn" onClick={() => navigate(-1)}>
            ←
          </button>
          <h1>Sub Category Creation</h1>
          <span className="parent-label">Parent Category:</span>
              <span className="parent-name">{category.name}</span>
        </div>

        <div className="subcategory-form-wrapper">
          <div className="subcategory-form-card">
            {/* Parent Category Info */}
            

            <form onSubmit={handleSubmit}>
              {/* Sub Category Name Field */}
              <div className="subcategory-form-group">
                <label className="subcategory-form-label">
                  Sub Category Name <span className="subcategory-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Eg. Wireless Headphones, Smartphones"
                  className="subcategory-form-input"
                />
              </div>

              {/* Description Field */}
              <div className="subcategory-form-group">
                <label className="subcategory-form-label">Description (Optional)</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Brief summary of sub-category"
                  className="subcategory-form-textarea"
                  rows="3"
                />
              </div>

              {/* Status Field */}
              <div className="subcategory-form-group">
                <label className="subcategory-form-label">Status</label>
                <div className="subcategory-status-buttons">
                  <button
                    type="button"
                    className={`subcategory-status-btn ${formData.status === 'active' ? 'subcategory-status-active' : ''}`}
                    onClick={() => handleStatusChange('active')}
                  >
                    Active
                  </button>
                  <button
                    type="button"
                    className={`subcategory-status-btn ${formData.status === 'inactive' ? 'subcategory-status-inactive' : ''}`}
                    onClick={() => handleStatusChange('inactive')}
                  >
                    Inactive
                  </button>
                </div>
              </div>

              {/* Image Upload Field */}
              <div className="subcategory-form-group">
                <label className="subcategory-form-label">Image</label>
                <div 
                  className={`subcategory-image-upload-area ${dragActive ? 'subcategory-drag-active' : ''}`}
                  onClick={() => fileInputRef.current?.click()}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  {imagePreview ? (
                    <div className="subcategory-image-preview-container">
                      <img src={imagePreview} alt="Preview" className="subcategory-image-preview" />
                      <button 
                        type="button"
                        className="subcategory-remove-image-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          setImagePreview('');
                          setFormData(prev => ({ ...prev, image_url: '' }));
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div className="subcategory-upload-placeholder">
                      <div className="subcategory-upload-icon">📤</div>
                      <p className="subcategory-upload-text">
                        <span className="subcategory-browse-link">Choose file</span> or drag here
                      </p>
                      <p className="subcategory-upload-hint">Png, Jpg, up to 5MB</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="subcategory-form-actions">
                <button 
                  type="button" 
                  className="subcategory-cancel-btn"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className={`subcategory-submit-btn ${isFormValid ? 'subcategory-active' : 'subcategory-disabled'}`}
                  disabled={!isFormValid}
                >
                  Create Sub Category
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategoryCreateComponent;